import {
  AlertDialog as ChakraAlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Flex,
} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {useTranslation} from 'hooks';
import {FC, PropsWithChildren, ReactNode, useRef} from 'react';

interface Props {
  title?: ReactNode;
  isOpen: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
  successButtonValue?: string;
  cancelButtonValue?: string;
  disabledSuccessButton?: boolean;
  closeOnConfirm?: boolean;
  disableBtns?: boolean;
  reverseButtons?: boolean;
}

export const AlertDialog: FC<PropsWithChildren<Props>> = ({
  title,
  children,
  isOpen,
  onClose,
  onConfirm,
  successButtonValue,
  cancelButtonValue,
  disabledSuccessButton,
  closeOnConfirm = true,
  disableBtns,
  reverseButtons,
}) => {
  const cancelRef = useRef<any>();
  const {t} = useTranslation();

  const handleConfirm = () => {
    onConfirm && onConfirm();
    closeOnConfirm && onClose && onClose();
  };

  return (
    <ChakraAlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={() => onClose && onClose()}>
      <AlertDialogOverlay>
        <AlertDialogContent w="90%">
          {title && <AlertDialogHeader>{title}</AlertDialogHeader>}
          {children && <AlertDialogBody p={['15px', '25px']}>{children}</AlertDialogBody>}
          {!disableBtns && (
            <AlertDialogFooter mt={['5px', '10px']} pb="20px">
              <Flex w="full" flexDirection={['column', 'row']} justifyContent="flex-end">
                {!reverseButtons ? (
                  <Button
                    fontSize={['12px', '16px']}
                    _focus={{border: '1px solid', borderColor: colors.black}}
                    onClick={onClose}
                    variant="outline"
                    mr={['0px', '15px']}
                  >
                    {cancelButtonValue ?? t('CANCEL')}
                  </Button>
                ) : null}

                <Button
                  mt={['10px', '0px']}
                  fontSize={['12px', '16px']}
                  variant="primary"
                  onClick={handleConfirm}
                  _focus={{border: 'none'}}
                  disabled={disabledSuccessButton}
                  w={['auto', '50%']}
                >
                  {successButtonValue ?? t('DELETE')}
                </Button>
                {reverseButtons ? (
                  <Button
                    mt={['10px', '0px']}
                    fontSize={['12px', '16px']}
                    _focus={{border: '1px solid', borderColor: colors.black}}
                    onClick={onClose}
                    variant="outline"
                    w={['auto', '50%']}
                    ml={['0px', '15px']}
                  >
                    {t('CANCEL')}
                  </Button>
                ) : null}
              </Flex>
            </AlertDialogFooter>
          )}
        </AlertDialogContent>
      </AlertDialogOverlay>
    </ChakraAlertDialog>
  );
};
